(function () {
  if (customElements.get('filter-value-cards')) return;

  class FilterValueCards extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('.filter-value-cards__slider');
      if (!this.slider || this.slider.children.length === 0) return;

      this.boundHandleClick = this.handleClick.bind(this);
      this.cleanupBreakpoint = window.SliderSettings.onBreakpointChange(() => {
        this.destroyFlickity();
        this.initFlickity();
      });

      this.initFlickity();
      this.slider.addEventListener('click', this.boundHandleClick);
    }

    disconnectedCallback() {
      if (this.slider && this.boundHandleClick) {
        this.slider.removeEventListener('click', this.boundHandleClick);
      }
      this.cleanupBreakpoint?.();
      this.destroyFlickity();
    }

    initFlickity() {
      if (typeof Flickity === 'undefined') return;
      // Local override: only drag when there are >1 cells.
      const opts = window.getFlickityOptions(this, null, { draggable: '>1' });
      this.flkty = new Flickity(this.slider, opts);

      const viewport = this.slider.querySelector('.flickity-viewport');
      if (viewport) viewport.setAttribute('tabindex', '-1');
      this.slider.setAttribute('tabindex', '-1');

      this.updateCardTabindex();
      this.flkty.on('select', () => this.updateCardTabindex());
      this.flkty.on('settle', () => this.updateCardTabindex());
      this.flkty.on('resize', () => this.updateCardTabindex());
    }

    updateCardTabindex() {
      const cards = this.slider.querySelectorAll('.filter-value-card');
      cards.forEach((card) => {
        if (card.tagName !== 'A') return;
        const cell = card.closest('.flickity-cell') || card;
        if (cell.getAttribute('aria-hidden') === 'true') {
          card.setAttribute('tabindex', '-1');
        } else {
          card.removeAttribute('tabindex');
        }
      });
    }

    destroyFlickity() {
      if (this.flkty) {
        this.flkty.destroy();
        this.flkty = null;
      }
    }

    handleClick(e) {
      const card = e.target.closest('.filter-value-card');
      if (!card || card.classList.contains('filter-value-card--disabled')) return;

      const filterName = card.dataset.filterName;
      const filterValue = card.dataset.filterValue;
      if (!filterName || !filterValue) return;

      const checkboxes = document.querySelectorAll(
        `input[name="${CSS.escape(filterName)}"][value="${CSS.escape(filterValue)}"]`
      );
      if (checkboxes.length === 0) return;

      const target =
        Array.from(checkboxes).find((cb) => cb.closest('form')?.offsetParent !== null) || checkboxes[0];
      const nextChecked = !target.checked;

      e.preventDefault();

      const savedScrollY = window.scrollY;
      const container = document.getElementById('FilterValueCards');
      if (container) {
        const observer = new MutationObserver(() => {
          window.scrollTo(0, savedScrollY);
          observer.disconnect();
        });
        observer.observe(container, { childList: true });
        setTimeout(() => observer.disconnect(), 5000);
      }

      checkboxes.forEach((cb) => {
        cb.checked = nextChecked;
      });
      /* DATORACODE - change-Event vor input-Event dispatchen, damit Single-Select-Listener
         in FacetFiltersForm Geschwister entcheckt, bevor der 800ms-Debounce-Submit feuert. */
      target.dispatchEvent(new Event('change', { bubbles: true }));
      target.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  customElements.define('filter-value-cards', FilterValueCards);
})();
